export default [
  {
    path: '/dashboard/settlement/contract/create',
    name: 'dashboard-settlement-contract-create',
    component: () => import('@/views/settlement/contract/create.vue'),
    meta: {
      title: '创建合同',
      type: 'single',
    },
  },
];
